// FALLBACKS / JS EXENTSIONS
// -------------------------
// console.log fallback for IE
var alertFallback = false;
if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = {};
    if (alertFallback) {
        console.log = function (msg) {
            alert(msg);
        };
    } else {
        console.log = function () { };
    }
}

// String.startsWith() fallback
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
      position = position || 0;
      return this.substr(position, searchString.length) === searchString;
  };
}

// String.trim() fallback
if (!String.prototype.trim) {
    (function() {
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        String.prototype.trim = function() {
            return this.replace(rtrim, '');
        };
    })();
}

// Object.keys fallback
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback, thisArg) {

    var T, k;

    if (this == null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== "function") {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

// block-header-poly IE fallback

// (function($){

jQuery(document).ready(function($) {

    var HeaderPolyFallback = function() {
        // ensure scrollbar is always on, stops calculations messing up
        $('html').css('overflow-y', 'scroll');

        this.$header = $('.block-header-poly');

        if ( !this.$header )
            return;

        this.$locations  = this.$header.find('.header-location');
        this.$body       = this.$header.find('.body-inner');
        this.$brandWrap  = this.$header.find('.brand-wrap');
        this.$middleWrap = this.$header.find('.middle-wrap');
        this.$toggleWrap = this.$header.find('.navbar-toggle-wrap');

        if ( !this.$locations )
            return;

        this.$header.addClass('fallback-mode');

        this.calculate(false);

        $(window).on('resize', this._onResize.bind(this));

    }

    HeaderPolyFallback.prototype = {
        constructor: HeaderPolyFallback,
        locationHash: {},
        _onResize: function( e ) {
            if ( this.firstResize === undefined ) {
                // block first resize event to prevent browser init causing extra recalc
                this.firstResize = false;
                return;
            } else {
                setTimeout(function(){
                    this.calculate();
                }.bind(this), 1);
            }
        },
        calculate: function( reset ) {
            reset = reset == undefined ? true : reset;
            if ( reset )
                this.reset();

            // set middle-wrap width
            // TODO: and child location(s)??
            var bodyWidth  = this.$body.innerWidth(),
                brandWidth = this.$brandWrap.outerWidth(true),
                middleWidth = (bodyWidth - brandWidth);

            this.$middleWrap.css('width', middleWidth);

            // divvy location elems into rows
            this.initLocationRows();

            // get options from header classes
            this.initHeaderOpts();

            // calc location heights
            this.setLocationHeights();


            if ( this.headerOpts['brand-position'] != null && this.headerOpts['brand-position'] != 'middle' ) {
                // set mobile-toggle container height
                this.setMobileToggleHeight();

                // adjust brand-wrap / middle-wrap heights
                this.stretchBody();

                // vertically center mobile toggle
                this.setMobileTogglePos();
            }

            // align elements vertically
            this.valignItems();
            // align elements horizontally
            this.halignItems();

        },
        reset: function() {
            var toReset = [
                this.$locations,
                this.$locations.children(),
                this.$body,
                this.$brandWrap,
                this.$middleWrap,
            ];

            toReset.forEach(function($el) {
                $el.attr('style','');
            });

        },
        getLocData: function( $location ) {
            var locData = $location.data('locData') != undefined ? $location.data('locData') : this.initLocData($location);
            return locData;
        },
        optsFromClasses: function( optsObj, classes ) {
            var keys = Object.keys(optsObj);
            for ( var i = 0; i < classes.length; i++ ) {
                var c = classes[i];
                for ( var k = 0; k < keys.length; k++ ) {
                    var key = keys[k];
                    if ( c.startsWith(key+'-') ) {
                        optsObj[ key ] = c.replace(key+'-', '');
                    }
                }
            }
            return optsObj;
        },
        // TODO: move these init funcs out of calculate
        initLocData: function( $location ) {
            var locData = {
                location: null,
                align: null,
                valign: null,
            };

            // extract classes
            locData.classes = this.extractClasses( $location );

            // get opts from classes
            locData = this.optsFromClasses(locData, locData.classes);

            // save references to locData
            this.locationHash[ locData.location ] = locData;

            $location.data('locData', locData);

            return locData;
        },
        initHeaderOpts: function() {
            var headerOpts = {
                'toggle-position': null,
                'brand-position': null,
                'mobile-view': null,
            }

            // extract classes from header
            headerOpts._classes = this.extractClasses( this.$header );

            // get opts from classes
            headerOpts = this.optsFromClasses(headerOpts, headerOpts._classes);

            // save refernce to headerOpts
            this.headerOpts = headerOpts;

        },
        initLocationRows: function() {
            // divvy location children into rows ready for width & positioning calculations
            this.$locations.each(function(idx, loc) {

                // TODO: determine when to not recalc
                var $loc      = $(loc),
                    locWidth  = $loc.width(),
                    curOffset = 0,
                    rows      = [],
                    curRowIdx = 0,
                    curRow    = null;

                function newRowObj() {
                    return {
                        height: 0,
                        itemWidths: 0,
                        offset: 0,
                        $items: null,
                        rowIdx: 0,
                    }
                };

                rows.push(newRowObj());

                curRow = rows[ curRowIdx ];

                $loc.children().each(function(idx, item) {
                    var $item    = $(item),
                        rowEmpty = curRow.$items == null,
                        newOffset = curOffset + $item.width();

                    switch (true) {
                        case ( rowEmpty ):
                            curRow.$items = $().add($item);
                            curOffset = newOffset;
                            break;
                        case (newOffset <= locWidth ):
                            // enough space in the row for item
                            curRow.$items = curRow.$items.add($item);
                            curOffset = newOffset;
                            break;
                        case ( newOffset > locWidth ):
                            // item needs to go in a new row
                            // calc new row offset
                            var newRowOffset = curRow.offset + curRow.height;
                            // create new row
                            rows.push(newRowObj());
                            curRowIdx++;
                            curRow = rows[ curRowIdx ];
                            curRow.rowIdx = curRowIdx;
                            // set new new row offset
                            curRow.offset = newRowOffset;

                            // add item to new row
                            curRow.$items = $().add($item);
                            // set new item offset
                            curOffset = $item.width();
                            break;

                    }

                    // add item height to row
                    curRow.height = $item.outerHeight(true) > curRow.height ? $item.outerHeight(true) : curRow.height;
                    // add item width to total width
                    curRow.itemWidths += $item.width();

                });

                // save rows on location elem
                $loc.data('rows', rows);
            });
        },
        setLocationHeights: function() {

            // var hasMobile = false;
            this.$locations.each(function(idx, loc){

                var $loc      = $(loc),
                    locData   = this.getLocData($loc),
                    rows      = $loc.data('rows'),
                    locHeight = 0;

                if ( locData.location == 'mobile' ) {
                    // TODO: handle mobile special cases
                    // hasMobile = true;
                    return;
                }

                // calculate total location height
                for ( var i = 0; i < rows.length; i++ ) {
                    locHeight += rows[i].height;
                }
                // set location height
                $loc.css('height', locHeight);

            }.bind(this));

        },
        valignItems: function() {
            this.$locations.each( function(locIdx, loc) {
                var $loc      = $(loc),
                    rows      = $(loc).data('rows'),
                    locData   = this.getLocData($loc),
                    locHeight = $loc.height();

                for ( var i = 0; i < rows.length; i++ ) {

                    var row = rows[i];
                    switch ( locData.valign ) {
                        case 'top':
                        case 'bottom':
                            row.$items.each(function(idx, item) {
                                var rowOffset = rows.length == 1 ? 0 : row.offset,
                                    rowHeight = rows.length == 1 ? locHeight : row.height;

                                $(item).css({
                                    'top': locData.valign == 'bottom' ? ((rowOffset + rowHeight) - $(item).outerHeight(true)) : rowOffset,
                                    'position':'absolute',
                                });
                            });
                            break;
                        case 'baseline':
                        case 'middle':
                            // TODO: make parent even height if needs be
                            row.$items.each(function(idx, item) {
                                var $item     = $(item),
                                    rowHeight = rows.length == 1 ? locHeight : row.height,
                                    diff      = rowHeight - $item.outerHeight(true);
                                $item.css({
                                    'top': (row.offset + (diff / 2)),
                                    'position':'absolute',
                                });
                            });
                            break;
                        case 'stretch':
                            row.$items.each(function(idx, item) {
                                $(item).css('height', row.height);
                            });
                            break;
                    }
                }
            }.bind(this));

            return this;
        },
        halignItems: function() {
            this.$locations.each(function(idx, loc) {

                var $loc        = $(loc),
                    locData     = this.getLocData( $loc ),
                    align       = locData.align,
                    locWidth    = $loc.width(),
                    widths      = [],
                    rows        = $loc.data('rows');

                for ( var i = 0; i < rows.length; i++ ) {
                    var row = rows[i];
                    // position elements
                    switch ( align ) {
                        case 'right':
                        case 'left':
                        case 'center':
                            var lastVal   = align == 'center' ? (( locWidth / 2 ) - ( row.itemWidths / 2)) : 0,
                                alignProp = align == 'right' ? 'right' : 'left';

                            row.$items.each(function(idx, item) {
                                var $item = $(item),
                                    props = {
                                        'position': 'absolute',
                                    }
                                props[ alignProp ] = lastVal;
                                $item.css(props);
                                lastVal += $item.width();
                            });
                            break;
                        case 'justify':
                        case 'justify-inside':
                            var numSpaces  = align == 'justify' ? row.$items.length - 1 : row.$items.length + 1,
                                spaceWidth = ( locWidth - row.itemWidths ) / numSpaces,
                                lastVal    = align == 'justify' ? 0 : spaceWidth;

                            row.$items.each(function(idx, item) {
                                var $item = $(item),
                                    props = {
                                        'position': 'absolute',
                                        'left': lastVal,
                                    }
                                $item.css(props);
                                lastVal += $item.width() + spaceWidth;
                            });
                            break;
                    }
                }

            }.bind(this));

            return this;
        },
        stretchBody: function() {
            var totalHeight = this.$body.height(),
                toStretch   = totalHeight > this.$brandWrap.height() ? 'brand' : 'locations';
            switch (toStretch) {
                case 'brand':
                    this.$brandWrap.css('height', this.$body.height());
                    break;
                case 'locations':
                    var $locations = this.$middleWrap.find('.header-location, .navbar-toggle-wrap').filter(':visible'),
                        remainder = totalHeight % $locations.length;

                    if ( remainder ) { // height doesn't divide nicely, add difference to it
                        totalHeight = totalHeight + ($locations.length - remainder);
                        this.$brandWrap.css('height', totalHeight+'px');
                    }

                    var totalLocHeights = 0,
                        diff = 0;
                    $locations.each(function(){
                        totalLocHeights += $(this).outerHeight(true);
                    });

                    diff = (totalHeight - totalLocHeights) / $locations.length;

                    $locations.each(function(){
                        $(this).css('height', $(this).height() + diff );
                    });
                    break;
            }
        },
        setMobileToggleHeight: function() {
            // togglePostion is area toggleWrap replaces
            var togglePosition = this.headerOpts['toggle-position'];
            switch ( togglePosition ) {
                case 'middle':
                    this.$toggleWrap.css('height', this.$body.height());
                case 'top':
                case 'bottom':
                    // reset togglewrap height
                    this.$toggleWrap.css('height','');

                    // figure out new height
                    var $loc = this.$middleWrap.find('.location-'+togglePosition),
                        toggleHeight = Math.max( $loc.height(), this.$toggleWrap.outerHeight()),
                        tallest = 0;

                    this.$toggleWrap.children().each(function(){
                        if ( $(this).outerHeight(true) > tallest ) {
                            tallest = $(this).outerHeight(true);
                        }
                    });

                    // set new height
                    this.$toggleWrap.css('height', toggleHeight);
                    break;
            }
        },
        setMobileTogglePos: function() {
            var $toggle = this.$toggleWrap.find('.navbar-toggle'),
                mT = (this.$toggleWrap.innerHeight() - $toggle.outerHeight()) / 2;

            $toggle.css({
                marginTop: mT,
                position: 'static',
            });
        },
        extractClasses: function($el) {
            return $el.attr('class').toString().trim().split(' ');
        },
    }
    // Initialise fallback if applicable
    if ( !Modernizr.flexbox
        // || !Modernizr.flexwrap // TODO: RE-ADD, requires new Modernizr build
        ) {
        window.hPolyFallback = new HeaderPolyFallback();
    }

});
